export default {
    aggregateToolbar: {
        from: 'FROM',
        to: 'TO',
        countryFilter: 'Country filter',
        showSplit: 'Show split (forecast vs futures)',
        nothingToSplitTitle: 'No forecast feed for this range — nothing to split',
    },
}
